import { z } from 'zod';

// ─── Sync Event Payloads ────────────────────────────────────────────
// Zod schemas for data-sync domain events.

/** Trigger-only event — requests a full sync of all upstream data. */
export const SyncAllRequestedPayload = z.object({});

export type SyncAllRequestedPayload = z.infer<typeof SyncAllRequestedPayload>;

/** Requests KPI precache refresh for a single tenant (default filter snapshots). */
export const TenantKpiPrecacheRequestedPayload = z.object({
  tenantId: z.string().cuid2(),
});

export type TenantKpiPrecacheRequestedPayload = z.infer<typeof TenantKpiPrecacheRequestedPayload>;
